import { User, SecurityRole } from '@april9/stack9-sdk';

export enum AuthActionTypes {
  Logout = '[Auth] Logout',
  LogoutSuccess = '[Auth] Logout Success',
  LogoutFail = '[Auth] Logout Fail',

  FETCH_SESSION_REQUEST = '[App] Fetch Session Request',
  FETCH_SESSION_SUCCESS = '[App] Fetch Session Success',
  FETCH_SESSION_FAIL = '[App] Fetch Session Fail',
}

interface IAction {
  type: AuthActionTypes;
  payload?: any;
}

type AuthSessionUser = Pick<
  User,
  | 'id'
  | '_is_deleted'
  | 'first_name'
  | 'last_name'
  | 'full_name'
  | 'email'
  | 'is_active'
  | 'is_blocked'
> & {
  business_unit_id: string | null;
  sendbird_user_id: string | null;
  security_role: SecurityRole | null;
};

export interface IAuthState {
  isLoading: boolean;
  error: string | null;
  sessionFetched: boolean;
  sessionUser: AuthSessionUser | null;
}

const initialState: IAuthState = {
  isLoading: false,
  error: null,
  sessionFetched: false,
  sessionUser: null,
};

const reducer = (state: IAuthState, action: IAction): IAuthState => {
  switch (action.type) {
    case AuthActionTypes.Logout:
      return {
        ...state,
        isLoading: true,
      };
    case AuthActionTypes.LogoutSuccess:
      return {
        ...state,
        ...initialState,
        sessionUser: null,
      };
    case AuthActionTypes.LogoutFail:
      return {
        ...state,
        ...initialState,
      };

    case AuthActionTypes.FETCH_SESSION_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case AuthActionTypes.FETCH_SESSION_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        sessionFetched: true,
        sessionUser: { ...action.payload },
      };
    }

    case AuthActionTypes.FETCH_SESSION_FAIL: {
      return {
        ...state,
        isLoading: false,
        error: `Failed to fetch auth session.`,
      };
    }

    default:
      throw new Error();
  }
};

export { initialState };

export default reducer;
